import useSeo from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHero from "@/components/feature/PageHero";
import ContactForm from "@/pages/about/components/ContactForm";

const reviews = [
  {
    name: "小满",
    role: "百合同好 · 3 年",
    text: "以前找百合作品全靠朋友安利，自从用了同人志指南，分类清晰到哭，冷门佳作直接打开新世界。",
    avatar: "https://readdy.ai/api/search-image?query=soft%20warm%20portrait%20illustration%20avatar%20of%20a%20young%20woman%20with%20gentle%20smile%2C%20coral%20and%20cream%20palette%2C%20minimal%20round%20avatar%20style&width=120&height=120&seq=avatar-1&orientation=squarish",
  },
  {
    name: "阿澄",
    role: "耽美向 · 5 年",
    text: "配对推荐真的戳中我！每次都能根据我喜欢的类型精准命中，选书效率高太多了。",
    avatar: "https://readdy.ai/api/search-image?query=soft%20warm%20portrait%20illustration%20avatar%20of%20a%20young%20man%20with%20friendly%20smile%2C%20amber%20and%20cream%20palette%2C%20minimal%20round%20avatar%20style&width=120&height=120&seq=avatar-2&orientation=squarish",
  },
  {
    name: "夜航",
    role: "悬疑向 · 2 年",
    text: "冷门佳作这个栏目太宝藏了，很多小众神作都是在这里发现的，编辑部眼光真的稳。",
    avatar: "https://readdy.ai/api/search-image?query=soft%20warm%20portrait%20illustration%20avatar%20of%20a%20young%20woman%20with%20curious%20expression%2C%20coral%20and%20charcoal%20palette%2C%20minimal%20round%20avatar%20style&width=120&height=120&seq=avatar-3&orientation=squarish",
  },
];

export default function About() {
  useSeo({
    title: "关于我们 | 同人志指南的定位、理念与团队",
    description:
      "了解同人志指南：我们的品牌定位、内容原则、发展理念与用户口碑。坚持真实筛选与清晰分类，为热爱同人志的读者搭建一盏指路明灯。",
    path: "/about",
  });

  return (
    <div className="bg-background-50">
      <Navbar />
      <PageHero
        eyebrow="About Us"
        title="关于同人志指南"
        desc="我们是一群热爱同人创作的资深读者，致力于把优质的同人志作品以最清晰、最真诚的方式呈现给你。"
        crumbs={[{ label: "关于我们" }]}
      />

      {/* Brand intro */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div className="overflow-hidden rounded-3xl">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20cozy%20reading%20corner%20with%20comics%2C%20sketches%20and%20a%20lamp%20glowing%20golden%2C%20coral%20and%20cream%20tones%2C%20community%20creative%20mood%2C%20high%20detail&width=900&height=600&seq=about-intro&orientation=landscape"
              alt="同人志指南的阅读与创作氛围"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
          <div>
            <p className="text-sm font-medium uppercase tracking-widest text-accent-600">Brand Intro</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              为每一份热爱，找到对的方向
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              同人志指南成立于对「想看却不知从何看起」的共同困惑之上。我们相信，好的作品值得被更多人看见，也相信清晰的信息结构能让每一位读者少走弯路。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们不做算法式堆砌，而是以编辑部人工把关的方式，持续对作品进行全品类分类、CP 配对梳理与口碑筛选，让「选书」回归简单与愉悦。
            </p>
          </div>
        </div>
      </section>

      {/* Positioning / Philosophy / Principles */}
      <section className="bg-background-100 py-14 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <p className="text-sm font-medium uppercase tracking-widest text-accent-600">Our Principles</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">我们的定位与理念</h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
            {[
              { icon: "ri-compass-3-line", title: "清晰定位", text: "定位为同人志内容导航与筛选平台，不做流量堆砌，只做有价值的信息整理与推荐。" },
              { icon: "ri-archive-line", title: "真实筛选", text: "坚持编辑人工把关，宁缺毋滥。上榜作品均经编辑部阅读验证，杜绝空有噱头。" },
              { icon: "ri-seedling-line", title: "持续生长", text: "关注新作与社区口碑变化，不断优化分类体系与榜单内容，与同好一同成长。" },
            ].map((p) => (
              <div key={p.title} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading mt-4 text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="text-center">
          <p className="text-sm font-medium uppercase tracking-widest text-accent-600">User Reviews</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">同好们的真实评价</h2>
        </div>
        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {reviews.map((r) => (
            <figure key={r.name} className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-relaxed text-foreground-600">“{r.text}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img src={r.avatar} alt={`${r.name}的头像`} className="h-10 w-10 rounded-full object-cover" loading="lazy" />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{r.name}</p>
                  <p className="text-xs text-secondary-500">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section className="bg-background-100 py-14 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div>
              <p className="text-sm font-medium uppercase tracking-widest text-accent-600">Contact</p>
              <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">联系我们</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                无论是作品推荐、纠错反馈，还是希望加入编辑部一起共建，都欢迎通过下方表单或邮箱与我们联系。
              </p>
              <div className="mt-6 space-y-3">
                <a href="mailto:hello@doujinshi-guide.example" className="flex items-center gap-3 text-sm text-foreground-800 hover:text-primary-700">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-700"><i className="ri-mail-line"></i></span>
                  hello@doujinshi-guide.example
                </a>
                <a href="/faq" className="flex items-center gap-3 text-sm text-foreground-800 hover:text-primary-700">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-700"><i className="ri-question-line"></i></span>
                  前往常见问题
                </a>
              </div>
            </div>
            <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
              <h3 className="font-heading text-lg font-bold text-foreground-950">留言给我们</h3>
              <p className="mt-1 mb-5 text-sm text-secondary-500">我们会认真阅读每一条来信</p>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}